var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _path7, _circle3, _circle4, _path8, _polygon, _polygon2, _path9, _path10, _path11, _path12, _circle5, _path13, _path14, _path15, _path16, _rect, _path17, _path18, _path19, _path20, _path21, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path22, _path23, _path24, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogin1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 719.76946,
    height: 687.25,
    viewBox: "0 0 719.76946 687.25",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "home_cinema") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M908.88473,288.962V250.375h-6v38.587a8,8,0,1,0,6,0Z",
    transform: "translate(-240.11527 -106.375)",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M922.88473,678.375h-41v-498h-16v498H824.88467a36.99993,36.99993,0,0,0-36.99994,36.99994v.00006h172v-.00006A36.99994,36.99994,0,0,0,922.88473,678.375Z",
    transform: "translate(-240.11527 -106.375)",
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M787.96774,254.375h171.834L949.29391,123.03467A18.19786,18.19786,0,0,0,931.248,106.375H816.52145a18.19786,18.19786,0,0,0-18.0459,16.65967Z",
    transform: "translate(-240.11527 -106.375)",
    fill: "#791212"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M301.21292,563.91061H825.69163V510.36435c0-144.59875-117.6406-262.23935-262.23935-262.23935S301.21292,365.7656,301.21292,510.36435Z",
    transform: "translate(-240.11527 -106.375)",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M301.21292,563.91061H825.69163V510.36435c0-144.59875-117.6406-262.23935-262.23935-262.23935S301.21292,365.7656,301.21292,510.36435Z",
    transform: "translate(-240.11527 -106.375)",
    opacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M369.18754,582.44585H772.8198A81.09742,81.09742,0,0,0,691.826,502.813H450.18135A81.09742,81.09742,0,0,0,369.18754,582.44585Z",
    transform: "translate(-240.11527 -106.375)",
    fill: "#791212"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 81.00587,
    cy: 386.82709,
    r: 81.00587,
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.53304,
    cy: 386.82709,
    r: 81.00587,
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M751.55066,534.39152V564.5971H377.41336V534.39152H293.66153V681.614a34.011,34.011,0,0,0,34.011,34.011H801.29139a34.011,34.011,0,0,0,34.01111-34.011V534.39152Z",
    transform: "translate(-240.11527 -106.375)",
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.00587,
    cy: 386.82709,
    r: 16.47577,
    opacity: 0.2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.53304,
    cy: 386.82709,
    r: 16.47577,
    opacity: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M593.29318,238.87148s1.61972,30.77465,12.95775,37.25352,0,50.21127,0,50.21127L552.80022,327.956l-3.23944-51.831s6.47888-21.05634,3.23944-30.77465S593.29318,238.87148,593.29318,238.87148Z",
    transform: "translate(-240.11527 -106.375)",
    fill: "#ffb8b8"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "413.107 560.102 393.671 582.778 424.446 611.933 440.643 579.539 413.107 560.102",
    fill: "#ffb8b8"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "275.431 560.102 294.868 582.778 264.093 611.933 247.896 579.539 275.431 560.102",
    fill: "#ffb8b8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M642.69459,451.86444s116.61972,38.87324,110.14084,76.12676-56.69014,168.4507-56.69014,168.4507-27.53521,0-48.59155-29.15493l14.57747-32.39436s-6.47888-17.81691,4.85915-21.05634,17.8169-59.92958,17.8169-59.92958-82.60563-6.47887-100.42253-37.25352l-32.39437-77.74648Z",
    transform: "translate(-240.11527 -106.375)",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M526.07487,451.86444S409.45515,490.73768,415.934,527.9912s56.69014,168.4507,56.69014,168.4507,27.53522,0,48.59155-29.15493l-14.57746-32.39436s6.47887-17.81691-4.85916-21.05634-17.8169-59.92958-17.8169-59.92958,82.60564-6.47887,100.42254-37.25352l32.39436-77.74648Z",
    transform: "translate(-240.11527 -106.375)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M658.89177,706.16021s16.19718-14.57746,17.8169-3.23944-1.61972,56.69015-1.61972,56.69015,16.19719,34.01408-8.09859,34.01408-35.6338-25.91549-32.39436-51.831-11.338-35.6338-11.338-35.6338-17.8169-35.6338,0-38.87324,24.29577,4.85916,24.29577,4.85916S641.07487,701.30106,658.89177,706.16021Z",
    transform: "translate(-240.11527 -106.375)",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M509.87769,706.16021s-16.19719-14.57746-17.81691-3.23944,1.61972,56.69015,1.61972,56.69015S477.48332,793.625,501.77909,793.625s35.63381-25.91549,32.39437-51.831,11.338-35.6338,11.338-35.6338,17.8169-35.6338,0-38.87324-24.29578,4.85916-24.29578,4.85916S527.69459,701.30106,509.87769,706.16021Z",
    transform: "translate(-240.11527 -106.375)",
    fill: "#2f2e41"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 328.07227,
    cy: 113.86972,
    r: 37.25352,
    fill: "#ffb8b8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M573.85656,284.22359l-22.67606-17.8169-55.07042,25.91549-1.61972,147.39437s-34.01408,16.19718-24.29577,37.25352c0,0,29.15493,6.47887,42.11267,19.43662s85.84507-4.85915,116.61972-14.57746,38.87324-21.05634,38.87324-21.05634l-30.77465-43.7324,17.8169-111.76056L599.7782,268.25887Z",
    transform: "translate(-240.11527 -106.375)",
    fill: "#e6e6e6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M613.47841,194.88912a32.72327,32.72327,0,0,1-2.22094-3.4469c-1.15512-2.81332.66946-6.12871-1.03543-8.75574-1.7404-2.68175-6.15869-3.24731-9.16482-5.06919-4.63088-2.80657-5.47263-8.31373-9.81145-11.40651-3.12615-2.22838-7.58418-2.82906-11.76168-2.70194s-8.29915.88239-12.47838.96527a37.62165,37.62165,0,0,1-16.3771-3.34911l3.08305,6.03082a30.7761,30.7761,0,0,1-9.678-3.92278c-1.3636,1.69136,1.1312,4.25855-.41564,5.845a4.96343,4.96343,0,0,1-2.18434,1.01281,52.24553,52.24553,0,0,0-16.53785,8.06827,8.31019,8.31019,0,0,0-2.78289,2.93788c-.8036,1.7809-.09107,3.74785-.15191,5.64139-.11054,3.44069-2.73736,6.441-4.60127,9.54054s-2.87034,7.118-.10591,9.74867a25.13472,25.13472,0,0,1,1.9317,1.70333c2.76984,3.26725-2.1332,8.052.23,11.51909,1.02607,1.50533,3.1292,2.26716,4.95713,3.15648a19.80713,19.80713,0,0,1,8.4742,7.55282L531.42613,219.531a1.72023,1.72023,0,0,1,.2829-1.519c.68812-.70137,2.12943-.42179,3.07917-.88624,1.04507-.51108,1.124-1.68341,1.08247-2.66528l-.31984-7.57123c-.14382-3.40457-.1836-3.85668,2.32377-6.60478,1.75174-1.91993,4.50741-3.07833,7.27533-3.93024,6.3253-1.94679,13.12847-2.62018,19.85287-3.27824,7.809-.7642,16.60205-4.55325,22.66652-.53025,4.96433,3.2932,6.61488,8.70626,9.00682,13.507,2.15,4.315,7.668,17.02,12.26163,10.1427C611.82261,211.87644,616.235,199.698,613.47841,194.88912Z",
    transform: "translate(-240.11527 -106.375)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M574.583,209.438a.57962.57962,0,0,0-.5791.57861v15.59717a.57962.57962,0,0,0,.5791.57861h26.84961a.57962.57962,0,0,0,.5791-.57861V210.0166a.57962.57962,0,0,0-.5791-.57861Z",
    transform: "translate(-240.11527 -106.375)",
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M577.58346,210.81348a1.07985,1.07985,0,0,0-1.07861,1.07861v11.84619a1.07985,1.07985,0,0,0,1.07861,1.07861h20.84863a1.07985,1.07985,0,0,0,1.07861-1.07861V211.89209a1.07985,1.07985,0,0,0-1.07861-1.07861Z",
    transform: "translate(-240.11527 -106.375)",
    fill: "#ff6584"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 320.78354,
    y: 108.2007,
    width: 13.98592,
    height: 3.23944,
    fill: "#3f3d56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M536.562,209.438a.57952.57952,0,0,0-.57861.57861v15.59717a.57952.57952,0,0,0,.57861.57861h26.8501a.57953.57953,0,0,0,.57862-.57861V210.0166a.57953.57953,0,0,0-.57862-.57861Z",
    transform: "translate(-240.11527 -106.375)",
    fill: "#3f3d56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M539.563,210.81348a1.08,1.08,0,0,0-1.0791,1.07861v11.84619a1.08,1.08,0,0,0,1.0791,1.07861H560.4111a1.08,1.08,0,0,0,1.0791-1.07861V211.89209a1.08,1.08,0,0,0-1.0791-1.07861Z",
    transform: "translate(-240.11527 -106.375)",
    fill: "#791212"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M281.76944,297.75h93a14,14,0,0,1,14,14v0a0,0,0,0,1,0,0h-121a0,0,0,0,1,0,0v0A14,14,0,0,1,281.76944,297.75Z",
    fill: "#3f3d56"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M621.38473,403.125a4.96123,4.96123,0,0,0-1.59918.27228,2.99462,2.99462,0,0,0-5.90082.72772c0,.01495.00372.02881.004.0437a5.14183,5.14183,0,0,0-1.10321.22858,3.01113,3.01113,0,0,0-1.483-1.911,5.017,5.017,0,0,0,2.16407-2.36859,4.02054,4.02054,0,1,0-.08185-7.99268,4.96123,4.96123,0,0,0-1.59918.27228,2.99013,2.99013,0,1,0-5.749,1.62506c-.11956.08319-.23108.17663-.34283.26959a2.83951,2.83951,0,0,0-2.04492-.68066,4.98044,4.98044,0,0,0-9.68311,1.55066,5.11773,5.11773,0,0,0-1.18017.23535,2.9999,2.9999,0,0,0-.17249-.49353,3.75781,3.75781,0,0,0,1.27167-2.77875,4.27213,4.27213,0,0,0-4.5-4,4.96123,4.96123,0,0,0-1.59918.27228,2.99013,2.99013,0,1,0-5.749,1.62506,4.98706,4.98706,0,0,0-2.13726,3.8692c-.0423.0376-.09076.068-.13086.10791a3.56328,3.56328,0,0,0,.11627-.87445,4.27213,4.27213,0,0,0-4.5-4,4.96123,4.96123,0,0,0-1.59918.27228,2.99013,2.99013,0,1,0-5.749,1.62506,4.98694,4.98694,0,0,0,0,8.20532,2.72729,2.72729,0,0,0,0,1.79468,5.04888,5.04888,0,0,0-1.27935,1.29181,2.98133,2.98133,0,0,0-5.84162.50488,4.764,4.764,0,0,0-1.28564-.51941,5.02681,5.02681,0,0,0,1.83661-2.18194,4.02054,4.02054,0,1,0-.08185-7.99268,4.96123,4.96123,0,0,0-1.59918.27228,2.99013,2.99013,0,1,0-5.749,1.62506c-.06414.04462-.12194.09711-.1839.14459-.156-.01453-.30767-.04193-.46795-.04193a4.96123,4.96123,0,0,0-1.59918.27228c-.01892-.07544-.05-.14545-.07447-.21851a2.94689,2.94689,0,0,0-3.06225-3.5675,4.9952,4.9952,0,1,0-7.85071,5.56543,5.17336,5.17336,0,0,0-1.01257.22058,2.973,2.973,0,0,0-4.76184-1.6084,4.67579,4.67579,0,0,0-3.639-1.66388,4.96123,4.96123,0,0,0-1.59918.27228,2.99013,2.99013,0,1,0-5.749,1.62506,4.98907,4.98907,0,0,0-2.15185,4.10266c0,.0155.00445.02972.00458.04517a4.14774,4.14774,0,0,0-2.10376.22711,2.99013,2.99013,0,1,0-5.749,1.62506,4.97953,4.97953,0,0,0,3.93555,8.96979,4.98218,4.98218,0,0,0,9.414,1.27893,31.17007,31.17007,0,0,0,10.80249-.48676,4.9821,4.9821,0,0,0,9.278.33338,4.89172,4.89172,0,0,0,2.09741-.519,4.97708,4.97708,0,0,0,8.90259-.481,4.84375,4.84375,0,0,1,5.41815,3.00732,7.79929,7.79929,0,0,1,5.74383-3.17871,4.87476,4.87476,0,0,0,5.41455-2.06775,4.99772,4.99772,0,0,0,9.42347,3.23914,4.89172,4.89172,0,0,0,2.09741-.519,4.97708,4.97708,0,0,0,8.90259-.481,4.89172,4.89172,0,0,0,2.09741-.519,4.94793,4.94793,0,0,0,7.41247,1.43671,4.97874,4.97874,0,0,0,8.90613,2.06525,4.96583,4.96583,0,0,0,7.584-1.983,4.02054,4.02054,0,1,0-.08185-7.99268Zm-89.37818-2.06384c-.00524.02411-.00891.04883-.01385.07312-.0365-.00135-.07111-.00928-.108-.00928a2.9781,2.9781,0,0,0-.44556.04492c.00812-.018.01953-.03412.02741-.05224A4.9796,4.9796,0,0,0,532.00655,401.06116Zm41.779-1.66388c-.01459-.05823-.03955-.11176-.05744-.16858a5.0243,5.0243,0,0,0,1.73847-2.111,4.68136,4.68136,0,0,0,3.4768-1.57435,3.00916,3.00916,0,0,0-.05865.58167,2.96721,2.96721,0,0,0,.15185.89734,5.01837,5.01837,0,0,0-1.85888,2.437,4.90717,4.90717,0,0,0-3.39215-.062Zm29.95037.37286c-.002-.06128.00562-.12445.00159-.1853a2.98582,2.98582,0,0,0,.38111-.02588,4.95614,4.95614,0,0,0,.95263,1.76471c-.09442.02649-.19378.04242-.2857.07361A3.01575,3.01575,0,0,0,603.73592,399.77014Z",
    transform: "translate(-240.11527 -106.375)",
    fill: "#f9a825"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M517.958,409.125a10.441,10.441,0,0,0-10.42676,11.002l6.77149,93.11524a10.44058,10.44058,0,0,0,10.42675,9.88281H612.04a10.44058,10.44058,0,0,0,10.42676-9.88281l6.77148-93.11524a10.441,10.441,0,0,0-10.42675-11.002Z",
    transform: "translate(-240.11527 -106.375)",
    fill: "#3f3d56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 282.76946,
    y: 302.75,
    width: 6,
    height: 114,
    fill: "#791212"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 299.76946,
    y: 302.75,
    width: 6,
    height: 114,
    fill: "#791212"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 316.76946,
    y: 302.75,
    width: 6,
    height: 114,
    fill: "#791212"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 333.76946,
    y: 302.75,
    width: 6,
    height: 114,
    fill: "#791212"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 350.76946,
    y: 302.75,
    width: 6,
    height: 114,
    fill: "#791212"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 367.76946,
    y: 302.75,
    width: 6,
    height: 114,
    fill: "#791212"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M607.87064,465.632l-19.43662,11.338s-46.97183,38.87324-14.57746,45.35211,40.493-27.53521,40.493-27.53521l11.338-12.95774Z",
    transform: "translate(-240.11527 -106.375)",
    fill: "#ffb8b8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M515.5467,457.53345l19.43662,11.338s46.97183,38.87324,14.57746,45.35211-40.493-27.53521-40.493-27.53521l-11.338-12.95775Z",
    transform: "translate(-240.11527 -106.375)",
    fill: "#ffb8b8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M633.78614,303.66021l21.05633,1.61972s16.19719,14.57746,14.57747,34.01408c0,0,14.57746,42.11268,11.338,59.92958,0,0,3.23943,29.15493-1.61972,40.493S633.78614,494.787,633.78614,494.787s-37.25352-29.15493-35.63381-30.77465l48.59155-48.59155-24.29577-32.39436Z",
    transform: "translate(-240.11527 -106.375)",
    fill: "#e6e6e6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M496.11008,292.32218l-.80986.80986s-36.44366,15.38733-34.82394,34.82395c0,0-14.57747,42.11267-11.338,59.92957,0,0-3.23944,29.15493,1.61972,40.493s45.35211,55.07042,45.35211,55.07042,37.25352-29.15493,35.6338-30.77464l-48.59155-48.59155,24.29578-32.39437Z",
    transform: "translate(-240.11527 -106.375)",
    fill: "#e6e6e6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin1);
export default __webpack_public_path__ + "static/media/login1.95c00f1eecd3db9e74698c6d6017d6bf.svg";
export { ForwardRef as ReactComponent };